export const SET_TRADE_CATEGORIES_ERROR = 'SET_TRADE_CATEGORIES_ERROR';
export const SET_TRADE_CATEGORIES_LIST = 'SET_TRADE_CATEGORIES_LIST';
export const SET_TOTAL_AMOUNT_OF_TRADE_CATEGORIES = 'SET_TOTAL_AMOUNT_OF_TRADE_CATEGORIES';
export const SET_FETCHING_TRADE_CATEGORIES = 'SET_FETCHING_TRADE_CATEGORIES';
